import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { sendMessage } from '../../redux/messages/actions'
import { toggleNotes } from '../../redux/notes/actions'
import { logout, switchClient } from '../../redux/profile/actions'
import {
  isDueDiligenceClient,
  role,
  user,
  isSidebarOpen,
  isIntakeProspectClient,
  isAdminLoggedAsClient,
  clientInfo,
  clientMemberships,
} from '../../redux/profile/selectors'
import { title } from '../../redux/ui/selectors'
import HeaderClient from './HeaderClient'

const selector = createStructuredSelector({
  role,
  user,
  isSidebarOpen,
  isIntakeProspectClient,
  title,
  isDueDiligenceClient,
  isAdminLoggedAsClient,
  clientInfo,
  clientMemberships,
})
const actions = {
  toggleNotes,
  onLogout: logout,
  sendMessage,
  switchClient,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector(connector, HeaderClient)
